import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDialogOpen } from '../../../store/Actions';
import DialogTitle from '@mui/material/DialogTitle';
import { storeUserFriend } from '../../../firebase/Firestore';
import { UploadAvatar } from './UploadAvatar';

export function UploadFriendAvatar() {
    const dialogData = useSelector(state=>state.dialogData)
    const [friend, setFriend] = useState(dialogData.friend);
    const dispatch = useDispatch();

    const onDone = (updatedFriend = friend) => {
        const editFriendDialogData = {
            dialogTitle: 'Edit Friend: ' + updatedFriend.name,
            parentDialog: dialogData.editParentDialog || 'Friends',
            listDialog: dialogData.listDialog,
            friend: updatedFriend
        }
        dispatch(setDialogOpen(dialogData.parentDialog, editFriendDialogData))
    }

    const onCancel = () => {
        const editFriendDialogData = {
            dialogTitle: 'Edit Friend: ' + dialogData.friend.name,
            parentDialog: dialogData.editParentDialog || 'Friends',
            listDialog: dialogData.listDialog,
            friend: dialogData.friend
        }
        dispatch(setDialogOpen(dialogData.parentDialog, editFriendDialogData))
    }

    return (
        <>
            <DialogTitle>{dialogData.dialogTitle}</DialogTitle>
            <UploadAvatar 
                userAccount={friend}
                setUserAccount={setFriend}
                storeUserAccount={storeUserFriend}
                onDone={onDone}
                onCancel={onCancel}
            />
        </>
    );
}
